import Global from '../../js/constant.js'

const circle = {
  state: {
    circleMode : Global.circle_mode.public, //サークル モード（public/private）
    circleHashtagDivisionId : Global.hashtag_division_id.home, //サークル ハッシュタグ区分 デフォルト：ホーム
    circleHashtagId : null, //サークル ハッシュタグID
  },
  getters: {
    circleMode(state) { return state.circleMode },
    circleHashtagDivisionId(state) { return state.circleHashtagDivisionId },
    circleHashtagId(state) { return state.circleHashtagId },
  },
  mutations: {
    setCircleMode (state, value) {
      state.circleHashtagDivisionId = 1
      state.circleHashtagId = null
      state.circleMode = value
    },
    setCircleHashtagDivisionId (state, value) {
      state.circleHashtagId = null
      state.circleHashtagDivisionId = value
    },
    setCircleHashtagId (state, value) {
      state.circleHashtagId = value
    },
  },
  actions: {},
  modules: {}
}
export default circle